// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import UserPagingResultModel from '../../model/user-paging-result-model';
import UserPagingResultDTO from '../dto/user-paging-result-dto';
import dtoSchema from '../schemas/user-paging-result-schema';
import UserModel from '../../model/user-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class UserPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<UserPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => UserModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: UserModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<UserPagingResultDTO>): UserPagingResultModel;
  static toModel(dto: DeepPartial<UserPagingResultDTO> | undefined | null): UserPagingResultModel | undefined;
  static toModel(dto: DeepPartial<UserPagingResultDTO> | undefined | null): UserPagingResultModel | undefined {
    return dto ? new UserPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<UserPagingResultModel> | UserPagingResultModel): UserPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as UserPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for UserPagingResultModel, can not map to UserPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
